import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  useDisclosure,
  Stack,
  Button,
  Avatar,
  AvatarBadge,
} from '@chakra-ui/react';
import { Input } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { editTenantProfile } from '../service';
import { PrimaryButton } from '../../../components/CustomButton';
import { FiCamera } from 'react-icons/fi';
import { AuthContext } from '../../../context/authContext';
import { UserProfileContext } from '../../../context/userProfileContext';

export const EditProfile = () => {
  const { userProfile, setRefresh } = useContext(UserProfileContext);
  const {
    userInfo: { userId },
  } = useContext(AuthContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    const { tenantName, email, tenantPhone } = userProfile;
    setInitialValues({
      tenantName,
      tenantPhone,
      email,
    });
  }, [userProfile]);

  // console.log({ userProfile });

  const [profilePicture, setProfilePicture] = useState('');
  const [formValues, setFormValues] = useState(initialValues);
  const [isLoading, setIsLoading] = useState(false);
  // const [isDisabled, setIsDisabled] = useState(true);

  const changeHandler = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setFormValues(initialValues);
  }, [initialValues]);

  const handleImgUpload = (event) => {
    // Assuming only image
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    console.log({ file });
    reader.onloadend = function (e) {
      setProfilePicture({ imgUrl: reader.result, file: event.target.files[0] });
    };
  };

  const { tenantName, email, tenantPhone } = formValues;

  const handleUpdateProfile = (e) => {
    e.preventDefault();
    localStorage.setItem('savedProfilePic', profilePicture.file);

    const formData = new FormData();
    formData.append('tenantName', tenantName);
    formData.append('email', email);
    formData.append('tenantPhone', tenantPhone);
    formData.append(
      'profileImage',
      profilePicture.file || localStorage.getItem('savedProfilePic')
    );

    editTenantProfile(userId, formData, setIsLoading, onClose).then(() =>
      setRefresh({})
    );
  };

  return (
    <Box>
      <Button
        onClick={onOpen}
        bg='transparent'
        border='1px solid #FEE8E7'
        size='sm'
      >
        Edit Profile
      </Button>

      <Modal size='xs' isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalBody textAlign={'center'}>
            <label htmlFor='profile'>
              <Avatar
                src={
                  profilePicture
                    ? profilePicture.imgUrl
                    : userProfile.profilePicture
                }
                size='xl'
                name={userProfile?.tenantName}
              >
                <AvatarBadge boxSize='0.9em' bg='#95c0fa' border='4px'>
                  {' '}
                  <FiCamera />{' '}
                </AvatarBadge>
                <Input
                  onChange={handleImgUpload}
                  type='file'
                  id='profile'
                  display='none'
                />
              </Avatar>
            </label>

            <Stack spacing={5} borderColor='#F98B88' py='5'>
              {/* <Input placeholder='First Name' border='1px solid #F8CECC' /> */}
              <Input
                name='tenantName'
                placeholder='Enter your full name'
                border='1px solid rgb(7,47,100) !important'
                onChange={changeHandler}
                value={tenantName}
              />
              <Input
                type='email'
                name='email'
                placeholder='Email Address'
                border='1px solid rgb(7,47,100) !important'
                onChange={changeHandler}
                value={email}
              />
              <Input
                name='tenantPhone'
                placeholder='Phone Number'
                border='1px solid rgb(7,47,100) !important'
                onChange={changeHandler}
                value={tenantPhone}
              />
              <Box py='5'>
                <PrimaryButton
                  isLoading={isLoading}
                  // isDisabled={isDisabled}
                  width='100%'
                  height='40px'
                  color='#FFFFFF'
                  fontWeight='semibold'
                  btnText='Update Profile'
                  onClick={handleUpdateProfile}
                />
              </Box>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
